module.exports = __webpack_public_path__ + "static/media/MostAvailable-Icon.efb4d152.svg";